// extracted by mini-css-extract-plugin
export default {"selectCab":"SelectConfigCabine_selectCab__FTcin","selectCabContainer":"SelectConfigCabine_selectCabContainer__LP2NA","selectCabInput":"SelectConfigCabine_selectCabInput__ziuhr"};